import Base from 'app/views/base';
import { showError } from 'utils/messages';
import tmpl from 'templates/canada_post_account_registration_page';
import CanadaPostRegistration from 'app/models/canada_post_registration';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    const self = this;
    this.model = new CanadaPostRegistration({});
    this.model.fetch({
      success() {
        self.render();
        self.submit();
      },
      error() {
        showError('There was an issue communicating with CanadaPost, please try again later.');
      },
    });
  },

  context() {
    return {
      tokenID: this.model.get('tokenID'),
      platformID: this.model.get('platformID'),
      registrationURL: this.model.get('registrationURL'),
      returnURL: this.model.get('returnURL'),
    };
  },

  submit() {
    this.$('#cp_registration_form').submit();
  },
});



// WEBPACK FOOTER //
// ./app/views/canada_post_account_registration_page.js